{
  "titulo": "Audit trail",
  "entidades": {
    "empresa": "Company",
    "sucursal": "Branch",
    "deposito": "Warehouse",
    "puesto_de_caja": "Register",
    "punto_de_venta": "Point of sale",
    "parametro": "Setting",
    "rol": "Role",
    "membresia": "Person",
    "invitacion": "Invitation",
    "sesion": "Session"
  },
  "acciones": {
    "alta": "Created",
    "modificacion": "Modified",
    "baja": "Deactivated",
    "cambio_de_empresa": "Company switch",
    "invitacion_aceptada": "Invitation accepted"
  },
  "columnas": {
    "momento": "When",
    "quien": "Who",
    "que": "What",
    "accion": "Action",
    "desde": "From",
    "detalle": "Details"
  },
  "detalle": {
    "antes": "Before",
    "despues": "After",
    "sinCambios": "No data recorded"
  },
  "filtros": {
    "todas": "All",
    "desdeFecha": "From",
    "hastaFecha": "To"
  },
  "masResultados": "Show more",
  "descripcion": "Who did what, when and from where."
}
